<script>
  import { createEventDispatcher, onMount } from "svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import { querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import { checkValidOlderDate } from "../../../Publish/SinglePublish/script"
  import notify from "../../../../Script/notify"
  const dispatch = createEventDispatcher()

  /**
   * @type {Boolean}  whether to display filter form or not
   */
  export let showFilterForm

  /**
   * @type {Boolean}  to show all, active, pending, revoked status selection
   */

  /**
   * @type {Boolean}  to show all, single, bulk mode section
   */
  // export let mode = false

  /**
   * @type {Boolean} which type of parameter you are going to show name, id, metadata, title
   */
  // export let searchparam = true

  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {String} - from date of filter list
   */
  let startDate

  /**
   * @type {String} - to date of filter list
   */
  let endDate

  /**
   * @type {String} - which state document need to show
   */
  let checked

  /**
   * @type {String} - which state document need to show
   */
  let modeStatus = "all"

  /**
   * @type {String} - what value need to search
   */
  let searchvalue

  /**
   * @type {String} - on which param need to show
   */
  let searchParam = "uuid"

  /**
   * @type {Boolean} - whether to disable sreach model or not
   */
  let searchTypeModal = false

  /**
   * @type {Boolean} - whether to disable sreach model or not
   */
  let status = false

  /**
   * @description function for filter the list based on user input
   */
  let filterData = {
    search: {},
    date: {},
  }

  /**
   * @type {dateValidation} - document releasing notification
   */
  let dateValidation = {
    close() {},
  }

  /**
   * @type {dateValidation} - id character length error notification
   */
  let idValidation = {
    close() {},
  }

  let timer
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  let closeNotification = {
    close() {},
  }

  /**
   * initial value assigned
   */
  onMount(() => {
    const timeZoneOffsetMilliseconds = new Date().getTimezoneOffset() * 60000 // Convert minutes to milliseconds
    startDate = query.sdate ? new Date(new Date(query.sdate).getTime() - timeZoneOffsetMilliseconds).toISOString().slice(0, 16) : ""
    endDate = query.edate ? new Date(new Date(query.edate).getTime() - timeZoneOffsetMilliseconds).toISOString().slice(0, 16) : ""
    // startDate = query.sdate ? query.sdate.slice(0, 16) : ""
    // endDate = query.edate ? query.edate.slice(0, 16) : ""
    searchvalue = query.sname ? query.sname : ""
    searchParam = query.sin ? query.sin : "uuid"
    modeStatus = query.mode ? query.mode : "all"
    status = query.status ? query.status : ""
    checked = query.status ? query.status : ""
  })

  /**
   * @description function for check the given date is not new
   */
  const checkDate = (e) => {
    dateValidation.close()
    let value = ""
    let response = checkValidOlderDate(e)
    if (!response) {
      e.target.value = ""
      const info = "PAGE: Docket List Date Filter\nEVENT: On selecting a future date in the date input."
      dateValidation = notify.danger("Don't select future date", info)
    } else value = e.target.value
    return value
  }

  const filterList = () => {
    console.log({ filterData })

    searchvalue = searchvalue.trim()
    idValidation.close()
    filterData.date.status = checked
    filterData.mode = modeStatus
    filterData.search.searchParam = searchParam
    startDate ? (filterData.date.startDate = new Date(startDate).toISOString()) : (filterData.date.startDate = "")
    endDate ? (filterData.date.endDate = new Date(endDate).toISOString()) : (filterData.date.endDate = "")
    searchvalue ? (filterData.search.searchvalue = searchvalue) : (filterData.search.searchvalue = "")
    if (searchParam == "id") {
      if (searchvalue.length != 24) {
        const info = "PAGE: Docket List Filter\nEVENT: When filtering using an invalid ID."
        idValidation = notify.danger("ID value must be 24 characters", info)
        return
      }
    }
    showFilterForm = false
    // console.log(filterData)

    dispatch("callFilter", filterData)
  }

  const validateDate = () => {
    if (new Date(startDate) > new Date(endDate)) {
      startDate = ""
      endDate = ""
      const info = "PAGE: Docket List Filter\nEVENT: On selecting 'To Date' before 'From Date'"
      dateValidation = notify.danger("The 'To Date' should not precede or be earlier than the 'From Date'.", info)
    }
  }
</script>

<form on:submit|preventDefault|stopPropagation={filterList} class="absolute right-0 top-[90px] z-20 w-full space-y-3 rounded-md border border-[#a0a1a580] bg-white px-3 pb-3 pt-3 shadow-md dark:bg-darkgray mobile:w-auto sm:px-6 sm:pt-6">
  <div>
    <div class="mb-3 flex items-center gap-3 text-xl dark:text-white">
      <i class="fa-solid fa-magnifying-glass" />
      <span class="text-lg font-semibold">Search In</span>
    </div>
    <div class="p-2">
      <!-- <form class="group relative flex w-full justify-between gap-3 sm:justify-end"> -->
      <input on:click|self={() => (searchTypeModal = !searchTypeModal)} on:blur={() => setTimeout(() => (searchTypeModal = false), 100)} placeholder="Search by {searchParam}" type="text" bind:value={searchvalue} class="w-full rounded-md border border-[#a0a1a580] bg-white py-2 pl-3 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:bg-transparent dark:text-white dark:placeholder:text-gray-200 sm:pr-9 sm:text-sm md:w-full" />
      <!-- <button type="submit" class="absolute right-0 z-10 hidden h-9 w-9 cursor-pointer items-center justify-center text-base font-semibold text-gray-800 hover:text-blue-400 focus:outline-none active:text-blue-600 group-focus:text-blue-500">
          <i class="fa-solid fa-magnifying-glass" />
        </button> -->
      <!-- </form> -->
      <div class="w-full rounded-md bg-white py-3 dark:bg-darkgray">
        <!-- <h1 class="pb-2 text-sm font-bold">Search in</h1> -->
        <div class="flex w-full flex-wrap gap-2">
          <button
            on:click={() => {
              searchParam = "uuid"
              searchTypeModal = false
            }}
            type="button"
            class="w-1/5 rounded-full text-xs sm:text-sm {searchParam == 'uuid' ? 'bg-blue-500 text-white hover:bg-blue-400 dark:text-white' : 'text-gray-800  hover:bg-blue-600 hover:text-white dark:hover:bg-blue-600 dark:hover:text-white'} border border-[#a0a1a580] p-2 py-1 text-center dark:text-gray-200"
          >
            UUID
          </button>

          <button
            on:click={() => {
              searchParam = "name"
              searchTypeModal = false
            }}
            type="button"
            class="w-1/5 rounded-full text-xs sm:text-sm {searchParam == 'name' ? 'bg-blue-500 text-white hover:bg-blue-400 dark:text-white' : 'text-gray-800  hover:bg-blue-600 hover:text-white dark:hover:bg-blue-600 dark:hover:text-white'} border border-[#a0a1a580] p-2 py-1 text-center dark:text-gray-200"
          >
            Name
          </button>
          <button
            on:click={() => {
              searchParam = "id"
              searchTypeModal = false
            }}
            type="button"
            class="w-1/5 rounded-full text-xs sm:text-sm {searchParam == 'id' ? 'bg-blue-500 text-white hover:bg-blue-400 dark:text-white' : 'text-gray-800  hover:bg-blue-600 hover:text-white dark:hover:bg-blue-600 dark:hover:text-white'} border border-[#a0a1a580] p-2 py-1 text-center dark:text-gray-200"
          >
            ID
          </button>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="flex items-center gap-3 text-xl dark:text-slate-200">
      <i class="fa-solid fa-filter-list" />
      <span class="-200 text-lg font-semibold">Filter</span>
    </div>
    <div class="p-2">
      <!-- <p class="text-xs text-gray-200 md:text-sm">You can filter the table list using below details.</p> -->
      <!-- <h1 class="text-sm font-bold">Date</h1> -->
      <div class="flex items-center pt-6">
        <div class="relative w-1/2 border-r border-[#a0a1a580] pr-3">
          <input
            on:input={(e) => {
              startDate = checkDate(e)
              validateDate()
            }}
            style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'} ;"
            type="datetime-local"
            bind:value={startDate}
            class="dateInput z-20 w-full border-none bg-transparent text-xs font-bold text-blue-500 outline-none placeholder:font-normal placeholder:text-blue-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 sm:pl-9 sm:pt-2 sm:text-sm"
          />
          <div class="absolute -top-2 left-1 z-10 hidden text-xl text-blue-500 sm:block">
            <i class="fa-solid fa-calendar-days text-base sm:text-2xl" />
          </div>
          <p class="absolute -top-4 text-xs dark:text-slate-200 sm:left-9 sm:text-sm">From&nbsp;Date</p>
        </div>
        <div class="relative ml-3 w-1/2">
          <input
            on:input={(e) => {
              endDate = checkDate(e)
              validateDate()
            }}
            style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'} ;"
            type="datetime-local"
            bind:value={endDate}
            class="dateInput z-20 w-full border-none bg-transparent text-xs font-bold text-blue-500 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 sm:pl-9 sm:pt-2 sm:text-sm"
          />
          <div class="absolute -top-2 left-1 z-10 hidden text-2xl text-blue-500 sm:block">
            <i class="fa-solid fa-calendar-days text-base sm:text-2xl" />
          </div>
          <p class="absolute -top-4 text-xs dark:text-slate-200 sm:left-9 sm:text-sm">To&nbsp;Date</p>
        </div>
      </div>
      <div class="py-3">
        <h1 class="pb-3 text-sm font-bold dark:text-slate-200">Status</h1>
        <div class="flex">
          <button type="button" on:click={() => (checked = "")} class="{checked == '' ? 'bg-violet-500 text-white' : ''} h-9 w-1/3 rounded-l-md border-2 border-[#a0a1a580] text-xs text-gray-800 hover:bg-violet-600 hover:text-white active:bg-violet-400 dark:text-slate-200 sm:text-sm">All</button>
          <button type="button" on:click={() => (checked = "PENDING")} class="{checked == 'PENDING' ? 'bg-yellow-500 text-white' : ''} h-9 w-1/3 border-y-2 border-[#a0a1a580] text-xs text-gray-800 hover:bg-yellow-600 hover:text-white active:bg-yellow-400 dark:text-slate-200 sm:text-sm">Pending</button>
          <button type="button" on:click={() => (checked = "COMPLETED")} class="{checked == 'COMPLETED' ? 'bg-green-500 text-white' : ''} h-9 w-1/3 rounded-r-md border-2 border-[#a0a1a580] text-xs text-gray-800 hover:bg-green-600 hover:text-white active:bg-green-400 dark:text-slate-200 sm:text-sm">Completed</button>
        </div>
        <div class="mt-1 flex">
          <button type="button" on:click={() => (checked = "APPROVED")} class="{checked == 'APPROVED' ? 'bg-blue-500 text-white' : ''} h-9 w-1/3 rounded-l-md border-2 border-[#a0a1a580] text-xs text-gray-800 hover:bg-blue-600 hover:text-white active:bg-blue-400 dark:text-slate-200 sm:text-sm">Approved</button>
          <button type="button" on:click={() => (checked = "SIGNED")} class="{checked == 'SIGNED' ? 'bg-lime-500 text-white' : ''} h-9 w-1/3 border-y-2 border-[#a0a1a580] text-xs text-gray-800 hover:bg-lime-600 hover:text-white active:bg-lime-400 dark:text-slate-200 sm:text-sm">Signed</button>
          <button type="button" on:click={() => (checked = "REJECTED")} class="{checked == 'REJECTED' ? 'bg-red-500 text-white' : ''} h-9 w-1/3 rounded-r-md border-2 border-[#a0a1a580] text-xs text-gray-800 hover:bg-red-600 hover:text-white active:bg-red-400 dark:text-slate-200 sm:text-sm">Rejected</button>
        </div>
      </div>
    </div>
    <div class="flex justify-between border-t border-[#a0a1a580] pt-3">
      <button
        on:click={() => {
          showFilterForm = false
          // sortData = jsonData
        }}
        type="button"
        class="flex h-9 w-full cursor-pointer items-center justify-center px-2 text-sm font-medium text-red-500 hover:text-red-600 focus:outline-none active:text-red-500 disabled:cursor-not-allowed disabled:text-red-300 sm:text-base lg:px-4"
      >
        <i class="fa-solid fa-xmark" />
        &nbsp;&nbsp;Close
      </button>
      <button
        on:click={async () => {
          filterData = {
            search: {
              searchParam: "uuid",
              searchvalue: "",
            },
            mode: "all",
            date: {
              status: "",
              startDate: "",
              endDate: "",
            },
          }
          dispatch("callFilter", filterData)
        }}
        type="button"
        class="flex h-9 w-full cursor-pointer items-center justify-center border-l border-[#a0a1a580] px-2 text-sm font-medium text-blue-500 hover:text-blue-600 focus:outline-none active:text-blue-500 disabled:cursor-not-allowed disabled:text-blue-300 sm:text-base lg:px-4"
      >
        <i class="fa-solid fa-rotate-left" />
        &nbsp;&nbsp;Reset
      </button>
      <button type="submit" class="flex h-9 w-full cursor-pointer items-center justify-center border-l border-[#a0a1a580] px-2 text-sm font-medium text-green-500 hover:text-green-600 focus:outline-none active:text-green-500 disabled:cursor-not-allowed disabled:text-green-300 sm:text-base lg:px-4">
        <i class="fa-solid fa-check" />
        &nbsp;&nbsp;Apply
      </button>
    </div>
  </div>
</form>

<style>
  input.dateInput {
    position: relative;
  }

  input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
</style>
